import { createFileRoute } from '@tanstack/react-router';
import { ToolEditorPage } from '@/pages/member-portal/tools/ToolEditorPage';

// Tool editor. `$id` is either a tool id (edit) or the literal `new`.
function MemberPortalToolEditorRoute() {
	return <ToolEditorPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/tools/$id')({
	component: MemberPortalToolEditorRoute,
});
